// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__KlxcL","filesListContainer":"PosDisputesFiles_filesListContainer__2zZ_X","filesButton":"PosDisputesFiles_filesButton__W4X8_"};